<template lang="pug">
  div
    div(v-if="data.body.content.call_registration!==undefined && Object.keys(data.body.content.call_registration).length>0")
      h5 Данные о регистрация вызова
      table.table.table-striped.table-bordered
        tr
          td Дата и время вызова
          td
            span(v-if="data.body.content.call_registration.call_datetime!==undefined") {{data.body.content.call_registration.call_datetime | datetime}}
            span(v-if="data.body.content.call_registration.call_datetime===undefined") —
        tr
          td Статус вызова
          td {{answerForm(data.body.content.call_registration.call_status, 3)}}

    div(v-if="data.body.content.patient_status!==undefined && Object.keys(data.body.content.patient_status).length>0")
      h5 Состояние пациента на момент прибытия команды СМП
      table.table.table-striped.table-bordered
        tr(v-if="data.body.content.patient_status.patient_condition_arrival_team!==undefined")
          td Состояние опьянения
          td {{answerForm(data.body.content.patient_status.patient_condition_arrival_team.having_drunken_clinic, 2)}}
        tr(v-if="data.body.content.patient_status.patient_condition_arrival_team!==undefined")
          td Жалобы
          td {{answerForm(data.body.content.patient_status.patient_condition_arrival_team.complaints, 2)}}
        tr(v-if="data.body.content.patient_status.patient_condition_arrival_team!==undefined")
          td Анамнез
          td {{answerForm(data.body.content.patient_status.patient_condition_arrival_team.anamnesis, 2)}}
        tr
          td Общее состояние
          td {{answerForm(data.body.content.patient_status.general_state, 3)}}
        tr(v-if="data.body.content.patient_status.working_blood_pressure!==undefined")
          td Рабочее кровяное давление
          td {{answerForm(data.body.content.patient_status.working_blood_pressure.systolic_pressure, 2)}}/{{answerForm(data.body.content.patient_status.working_blood_pressure.diastolic_pressure, 2)}}
        tr(v-if="data.body.content.patient_status.blood_pressure!==undefined")
          td Кровяное давление
          td {{answerForm(data.body.content.patient_status.blood_pressure.systolic_pressure, 2)}}/{{answerForm(data.body.content.patient_status.blood_pressure.diastolic_pressure, 2)}}

        tr
          td Пульс
          td {{answerForm(data.body.content.patient_status.pulse, 2)}}
        tr
          td ЧСС в минуту
          td {{answerForm(data.body.content.patient_status.heart_rate, 2)}}
        tr
          td Частота дыхания в минуту
          td {{answerForm(data.body.content.patient_status.breathing_rate, 2)}}
        tr
          td Температура
          td {{answerForm(data.body.content.patient_status.temperature, 2)}}

      div(v-if="data.body.content.patient_status.ecg!==undefined && Object.keys(data.body.content.patient_status.ecg).length>0")
        h5 Данные ЭКГ
        table.table.table-striped.table-bordered
          tr
            td ЭКГ перед медицинским обслуживанием
            td(v-if="data.body.content.patient_status.ecg.ecg_before_medical_care!==undefined")
              div
                table.table.table-striped.table-bordered
                  thead
                    tr
                      th Параметр
                      th ЧСС
                      th ЭОС
                      th Ритм
                      th P
                      th Q
                      th PQ
                      th ГЛЖ
                      th QT
                      th QRS
                      th RR
                      th T
                      th ST
                  tbody
                    tr
                      td Значение
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.heart_rate, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.eos, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.tempo, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.p, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.q, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.pq, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.lvh, 1)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.qt, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.qrs, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.rr, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.t, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.st, 2)}}
            td(v-if="data.body.content.patient_status.ecg.ecg_before_medical_care===undefined ") —
          tr
            td Описание
            td(v-if="data.body.content.patient_status.ecg.ecg_before_medical_care!==undefined") {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.description, 2)}}
            td(v-if="data.body.content.patient_status.ecg.ecg_before_medical_care===undefined ") —
          tr
            td Заключение
            td(v-if="data.body.content.patient_status.ecg.ecg_before_medical_care!==undefined") {{answerForm(data.body.content.patient_status.ecg.ecg_before_medical_care.conclusion, 2)}}
            td(v-if="data.body.content.patient_status.ecg.ecg_before_medical_care===undefined ") —
          tr
            td ЭКГ после медицинского обслуживания
            td
              div(v-if="data.body.content.patient_status.ecg.ecg_after_medical_care")
                table.table.table-striped.table-bordered
                  thead
                    tr
                      th Параметр
                      th ЧСС
                      th ЭОС
                      th Ритм
                      th P
                      th Q
                      th PQ
                      th ГЛЖ
                      th QT
                      th QRS
                      th RR
                      th T
                      th ST
                  tbody
                    tr
                      td Значение
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.heart_rate, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.eos, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.tempo, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.p, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.q, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.pq, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.lvh, 1)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.qt, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.qrs, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.rr, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.t, 2)}}
                      td {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.st, 2)}}
              div(v-if="!data.body.content.patient_status.ecg.ecg_after_medical_care") —
          tr
            td Описание
            td(v-if="data.body.content.patient_status.ecg.ecg_after_medical_care") {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.description, 2)}}
            td(v-if="!data.body.content.patient_status.ecg.ecg_after_medical_care") —
          tr
            td Заключение
            td(v-if="data.body.content.patient_status.ecg.ecg_after_medical_care") {{answerForm(data.body.content.patient_status.ecg.ecg_after_medical_care.conclusion, 2)}}
            td(v-if="!data.body.content.patient_status.ecg.ecg_after_medical_care") —

    div(v-if="data.body.content.diagnosis!==undefined && Object.keys(data.body.content.diagnosis).length>0")
      h5 Диагноз
      table.table.table-striped.table-bordered
        tr
          td Код диагноза
          td(v-if="data.body.content.diagnosis.icd!==undefined") {{data.body.content.diagnosis.code}} {{data.body.content.diagnosis.diagnosis_text}}
          td(v-if="data.body.content.diagnosis.icd===undefined") —
        tr
          td Заключение клинического диагноза
          td {{answerForm(data.body.content.diagnosis.clinical_diagnosis_conclusion, 2)}}

</template>
<script>
export default {
  props: ['data'],

  methods: {
    answerForm(fact, type) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
